// This function works correctly for primitives only.
export const addUniqueElementToArray = (element, array) => {
    if (!array.includes(element)) {
        array.push(element);
    }
    return array;
};
